// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d1cafa2f","239":"41a9caae","453":"538a69c9","455":"d9eede27"}[chunkId] + ".chunk.js";
};